import React from "react"
import styled from "styled-components"
import NumberFormat from "react-number-format"
import ProductItem from "./ProductItem"

const StyledProductList = styled.div`
  display: block;
  width: 100%;

  .product-list-header {
    display: grid;
    grid-template-columns: 120px 4fr 2fr 2fr 150px 80px;
    text-align: center;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
    height: 70px;
    > span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 900;
    }
    @media screen and (max-width: 1000px) {
      display: none;
    }
  }
  .subtotal {
    display: grid;
    grid-template-columns: auto 150px 80px;
    margin-top: 50px;
    margin-left: 10px;
    .computed {
      text-align: center;
      font-weight: 900;
    }
    @media screen and (max-width: 1000px) {
      width: 90%;
      margin: 0 auto;
      padding-top: 20px;
      border-top: 1px solid #d9d9d9;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
      grid-row-gap: 20px;
      grid-template-areas:
        "label computed"
        "notif notif";
      .computed {
        grid-area: computed;
        text-align: right;
        padding-right: 10px;
      }
      .label {
        grid-area: label;
        padding-left: 10px;
      }
      .notif {
        grid-area: notif;
        text-align: center;
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    margin: 80px 0 70px 0;
    @media screen and (max-width: 1000px) {
      flex-direction: column-reverse;
    }
    > button {
      width: 300px !important;
      margin: 0 0 0 20px !important;
      @media screen and (max-width: 1000px) {
        width: 90%;
        margin: 10px auto;
      }
    }
  }
`

function Products({ products, quantity, helpers, subTotal, currency }) {
  return (
    <StyledProductList className="product-list">
      <div>
        <div>
          <div className="product-list-header">
            <span />
            <span />
            <span>Unit Price</span>
            <span>Quantity</span>
            <span>Total Price</span>
            <span />
          </div>
          {products.length > 0 &&
            products.map((product, i) => (
              <ProductItem
                key={product.id}
                quantity={quantity[i]}
                index={i}
                product={product}
                setQuantity={helpers.setQuantity}
                removeProduct={helpers.removeProduct}
                currency={currency}
              />
            ))}
        </div>
      </div>
      <div className="subtotal">
        <span className="notif">Shipping and taxes calculated at checkout</span>
        <span className="computed">
          <NumberFormat
            value={parseFloat(subTotal)}
            thousandSeparator={true}
            allowNegative={false}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType="text"
            renderText={val => <>{val}</>}
          />{" "}
          {currency}
        </span>
        <span className="label">Subtotal</span>
      </div>
      <div className="buttons">
        <button className="gray" type="button" onClick={helpers.clearProducts}>
          Clear All
        </button>
        <button className="black" type="submit">
          Proceed to Checkout
        </button>
      </div>
    </StyledProductList>
  )
}

export default Products
